import { memo, useMemo } from 'react';
import { STAGES } from '../../constants';
import { PipelineCard } from './PipelineCard';

export const Pipeline = memo(({ content, move, del, upd, user, clearPublished }) => {
  const stageColumns = useMemo(() =>
    STAGES.map(stage => ({
      ...stage,
      items: content.filter(c => c.status === stage.id)
    })),
    [content]
  );

  return (
    <div className="h-full flex flex-col">
      <h2 className="text-2xl font-bold text-slate-800 mb-4 flex-shrink-0">Content Pipeline</h2>

      {/* Scrollable Pipeline Container */}
      <div className="flex-1 bg-white rounded-2xl border border-slate-200 p-2 md:p-4 overflow-hidden">
        <div className="h-full overflow-x-auto overflow-y-auto">
          <div className="flex gap-3 md:gap-4 h-full min-h-[500px]">
            {stageColumns.map(stage => (
              <div key={stage.id} className="flex-shrink-0 w-64 md:w-80 flex flex-col">
                <div className={`${stage.color} rounded-t-xl px-4 py-3 flex items-center justify-between flex-shrink-0`}>
                  <div className="flex items-center gap-2">
                    <stage.icon className={`w-5 h-5 ${stage.text}`} />
                    <span className={`font-bold text-sm ${stage.text}`}>{stage.label}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    {stage.canClear && stage.items.length > 0 && (
                      <button
                        onClick={() => {
                          if (confirm('Clear all published content?')) clearPublished();
                        }}
                        className="text-xs px-2 py-1 bg-white/70 text-emerald-700 rounded-lg font-semibold hover:bg-white"
                      >
                        Clear All
                      </button>
                    )}
                    <span className={`text-sm ${stage.text} bg-white/60 px-2.5 py-0.5 rounded-full font-bold`}>
                      {stage.items.length}
                    </span>
                  </div>
                </div>
                <div className="bg-slate-100 rounded-b-xl p-3 flex-1 space-y-3 overflow-y-auto">
                  {stage.items.map(item => (
                    <PipelineCard
                      key={item.id}
                      item={item}
                      user={user}
                      move={move}
                      upd={upd}
                      del={del}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

Pipeline.displayName = 'Pipeline';
